import { render } from "./DishConfigEditor.vue?vue&type=template&id=7492913e&scoped=true"
import script from "./DishConfigEditor.vue?vue&type=script&lang=js"
export * from "./DishConfigEditor.vue?vue&type=script&lang=js"

import "./DishConfigEditor.vue?vue&type=style&index=0&id=7492913e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7492913e"]])

export default __exports__